export const formatDate = (dateString) => {
    if (!dateString || dateString === '0000-00-00' || dateString === null) {
        return 'N/A';
    }
    return new Date(dateString).toLocaleDateString('en-IN', {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
    });
};
